import React from "react";
import { formatDate } from "../../utils/formatDate";
import Button from "../Button";
import icnDownload from "../../assets/icons/icn-download.png";
import icnCheckGreen from "../../assets/icons/icn-check-green.svg";
import Icon from "../Icon";
import usePrescriptionDownload from "../../hooks/usePrescriptionDownload";

import "./styles.css";

function Row({ prescription }) {
  const { token, date, signed, practitionerName } = prescription;
  const { buttonProps } = usePrescriptionDownload(prescription);

  return (
    <>
      <td>{token}</td>
      <td>
        {signed ? (
          <Icon icon={icnCheckGreen} size={24} alt="icone de assinatura" />
        ) : (
          <></>
        )}
      </td>
      <td>{formatDate(date)}</td>
      <td>{practitionerName}</td>
      <td>
        <Button {...buttonProps} icon={icnDownload} />
      </td>
    </>
  );
}

export default Row;
